module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-eight3.272d566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-eight3.png
// module id = ZYZL
// module chunks = 0